const init = () => {
	const checkboxNode = document.querySelector(
		'.wp-header__mobile-menu input[type="checkbox"]'
	);
	const overlayNode = document.querySelector('.wp-header__menu-overlay');
	const menuNode = document.querySelector(
		'.wp-header__mobile-menu .wp-header__navigation'
	);
	const subMenuParentNodes = Array.from(
		menuNode?.querySelectorAll('li.menu-item-has-children')
	);

	checkboxNode.addEventListener('change', () => {
		if (checkboxNode.checked) {
			document.body.classList.add('lock');
			overlayNode.setAttribute('aria-hidden', false);
		} else {
			document.body.classList.remove('lock');
		}

		subMenuParentNodes.forEach((rootNode) =>
			rootNode.classList.remove('active')
		);
	});

	subMenuParentNodes.forEach((rootNode) => {
		const linkNode = rootNode.querySelector('a, button');
		const subMenuNode = rootNode.querySelector('.sub-menu');
		const backBtn = subMenuNode?.querySelector('.sub-menu__back');

		linkNode.addEventListener('click', (e) => {
			e.stopPropagation();
			e.preventDefault();

			rootNode.classList.add('active');
			subMenuNode.setAttribute('aria-hidden', false);
		});

		backBtn.addEventListener('click', () => {
			rootNode.classList.remove('active');
		});
	});

	overlayNode.addEventListener('transitionend', () => {
		if (!checkboxNode.checked)
			overlayNode.setAttribute('aria-hidden', true);
	});

	subMenuParentNodes
		.map((node) => node.querySelector('.sub-menu'))
		.forEach((node) => {
			node.addEventListener('transitionend', () => {
				if (!node.parentElement.matches('.active'))
					node.setAttribute('aria-hidden', true);
			});
		});
};

if (document.readyState !== 'loading') {
	init();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		init();
	});
}
